import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import {
  DEMORA,
  DEMORA_FAIL,
  DEMORA_RESET,
  DEMORA_SUCCESS,
} from "../ActionTypes";

export const wsGetDemora  =
  (idEspecialidad, idMedico, idTurno, flgListaPacientesEnEspera, nextStep) => (dispatch) => {
    dispatch({ type: DEMORA });

    axiosAutoCheck().then((respuesta) => {
      respuesta
        .get(`/Agenda/demora/${idEspecialidad}/${idMedico}/${idTurno}/${flgListaPacientesEnEspera}`)
        .then((resp) => {
          dispatch({ type: DEMORA_SUCCESS, payload: resp.data });
          if (nextStep) {
            nextStep(true, resp.data);
          }
        })
        .catch((err) => {
          dispatch({ type: DEMORA_FAIL, payload: err?.response?.data });
          if (nextStep) nextStep(false);
        });
    });
  };

export const resetDemora = () => (dispatch) => {
  dispatch({ type: DEMORA_RESET });
};
